export default defineNuxtRouteMiddleware(async function AuthMiddleware({ path }) {
  const { user } = await useAuth();

  if (!user) {
    return navigateTo('/en/login');
  }

  navigateTo(path);
});
